import * as React from "react";
import { forwardRef } from "react";
const SvgWarningOutlined = (props, ref) => /* @__PURE__ */ React.createElement("svg", {
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	ref,
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M10 0C4.478 0 0 4.478 0 10s4.478 10 10 10 10-4.478 10-10S15.522 0 10 0Zm0 18.304A8.305 8.305 0 0 1 1.696 10 8.305 8.305 0 0 1 10 1.696 8.305 8.305 0 0 1 18.304 10 8.305 8.305 0 0 1 10 18.304Z",
	fill: "currentColor"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M8.929 13.929a1.071 1.071 0 1 0 2.142 0 1.071 1.071 0 0 0-2.142 0Zm.535-2.5h1.072a.18.18 0 0 0 .178-.179V5.179A.18.18 0 0 0 10.536 5H9.464a.18.18 0 0 0-.178.179v6.071c0 .098.08.179.178.179Z",
	fill: "currentColor"
}));
const ForwardRef = forwardRef(SvgWarningOutlined);
export default ForwardRef;
